export const eventLabels = {
    UPGRADE_SUBSCRIPTION: 'Upgrade subscription',
    PRICING: 'Pricing',
    CONNECT_APP: 'Connect app',
    SIGN_UP: 'Sign up',
    DISCONNECT_APP: 'Disconnect app',
    CONFIRMED_CONNECTION: 'Confirmed connection',
    AUDIENCE_SELECTION: 'Audience selection',
    CONFIRM_SYNC: 'Confirm sync',
    UPDATE_SETTINGS: 'Update settings',
    MANAGE_SETTINGS: 'Manage settings',
    MANAGE_SUBSCRIPTION: 'Manage subscription',
    UPDATE_APP: 'Update App',
    CONTACT_TYPE_SELECTED: 'Select contact type',
    CONTACT_TYPE_DESELECTED: 'Deselect contact type',
    CONTACT_SEGMENT_SELECTED: 'Select segment',
    CONTACT_SEGMENT_DESELECTED: 'Deselect segment',
    PAID_VERSION: 'Paid version',
    FREE_VERSION: 'Free version',
    AFFILIATE_PROGRAM: 'Affiliate program',
    SHOPIFY_ACCOUNT_SETUP: 'Payment gateway setup',
    SHOPIFY_REVENUE: 'Revenue',
    SHOPIFY_EXPENSES: 'Expenses',
    SHOPIFY_SYNC_HISTORY: 'Sync history',
    SHOPIFY_SYNC_HISTORY_RANGE: 'Sync history date range',
    SHOPIFY_ACCOUNT_AND_TAX_SETUP: 'Account and tax setup',
};
